// Highlighting for code blocks
import 'prismjs/themes/prism.css';
import '@fontsource/chivo';
import '@fontsource/work-sans/400.css';
import '@fontsource/work-sans/500.css';
import '@fontsource/work-sans/600.css';
import '@fontsource/work-sans/700.css';
